"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToPropBets = void 0;
function mapToPropBets(responses, players, events) {
    const groupedResponse = responses.reduce((obj, item) => {
        ;
        (obj[item.sportsbookMarketId] = obj[item.sportsbookMarketId] || []).push(item);
        return obj;
    }, {});
    const result = Object.values(groupedResponse).map((values) => {
        const event = events.find((event) => event.id === values.map((v) => v.gameId)[0]);
        return {
            event,
            market: values[0].market,
            sportsBookEventId: values[0].sportsbookEventId,
            sportsBookMarketId: values[0].sportsbookMarketId,
            options: values.map((value) => {
                const player = players.find((player) => player.id === value.playerId);
                return {
                    name: value.name,
                    text: value.analysisText,
                    type: value.analysisDetails.type,
                    sportsBookOptionId: value.sportsbookOptionId,
                    player,
                    playerGrade: {
                        facet: value.analysisDetails.selfGradeFacet,
                        grade: value.analysisDetails.selfGradeValue,
                        rank: value.analysisDetails.selfGradeRank,
                        totalRank: value.analysisDetails.selfGradeRankTotal,
                    },
                    oppositionName: value.analysisDetails.versusName,
                    oppositionGrade: {
                        facet: value.analysisDetails.versusGradeFacet,
                        grade: value.analysisDetails.versusGradeValue,
                        rank: value.analysisDetails.versusGradeRank,
                        totalRank: value.analysisDetails.versusGradeRankTotal,
                    },
                };
            }),
        };
    });
    return result;
}
exports.mapToPropBets = mapToPropBets;
//# sourceMappingURL=prop_bet_request.js.map